// extracted by mini-css-extract-plugin
export var icon = "_7e-1";
export var subtext = "_7e-0";